import { Link } from "react-router-dom";
import { mockProjects } from "../../../mocks/projects";

const featured = mockProjects.filter((p) => p.featured);

export default function FeaturedProjects() {
  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-white">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
        <div>
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">Selected Work</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-arch-charcoal font-light leading-tight">
            Featured Projects
          </h2>
        </div>
        <Link
          to="/projects"
          className="inline-flex items-center gap-2 text-arch-charcoal text-xs tracking-[0.15em] uppercase font-medium border-b border-arch-charcoal pb-0.5 hover:text-arch-gray hover:border-arch-gray transition-colors cursor-pointer whitespace-nowrap self-start lg:self-auto"
        >
          View All Projects
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      {/* Large first project */}
      <Link to={`/projects/${featured[0].id}`} className="group block mb-6 cursor-pointer">
        <div className="relative w-full h-[500px] lg:h-[620px] overflow-hidden rounded-lg">
          <img
            src={featured[0].image}
            alt={featured[0].title + " — Studio 1323"}
            className="w-full h-full object-cover object-top group-hover:scale-103 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
          <div className="absolute top-5 right-5">
            <span className="bg-white/20 backdrop-blur-sm text-white text-xs tracking-[0.1em] uppercase px-3 py-1.5 rounded-full">
              {featured[0].category}
            </span>
          </div>
          <div className="absolute bottom-8 left-8 right-8">
            <p className="text-white/60 text-xs tracking-wider uppercase mb-2">{featured[0].location} &nbsp;·&nbsp; {featured[0].year}</p>
            <h3 className="font-serif text-3xl lg:text-4xl text-white font-light">{featured[0].title}</h3>
            <p className="mt-2 text-white/70 text-sm font-light max-w-lg hidden lg:block">{featured[0].description}</p>
          </div>
          <div className="absolute bottom-8 right-8 w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-arrow-right-up-line text-white text-lg" />
          </div>
        </div>
      </Link>

      {/* Two smaller projects */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {featured.slice(1).map((project) => (
          <Link key={project.id} to={`/projects/${project.id}`} className="group block cursor-pointer">
            <div className="relative w-full h-72 lg:h-80 overflow-hidden rounded-lg">
              <img
                src={project.image}
                alt={project.title + " — Studio 1323"}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
              <div className="absolute top-4 right-4">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs tracking-[0.1em] uppercase px-3 py-1.5 rounded-full">
                  {project.category}
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white/60 text-xs tracking-wider uppercase mb-1">{project.location} &nbsp;·&nbsp; {project.year}</p>
                <h3 className="font-serif text-2xl text-white font-light">{project.title}</h3>
              </div>
              <div className="absolute bottom-6 right-6 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line text-white" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
